import { BACKDROPS, CLASS_IDS, PALETTE, paletteColor } from "@eldrun/content";

/**
 * Variáveis CSS da paleta fixa (Fase 8, doc 09 §5.1), geradas da fonte única em `@eldrun/content`:
 * nenhum hex de gameplay é escrito à mão no CSS. A CSP (`style-src 'self'`) permite definir
 * variáveis por `style.setProperty`.
 */
export function paletteTokens(colorblind = false): Record<string, string> {
  const c = (hex: string) => paletteColor(hex, colorblind);
  const tokens: Record<string, string> = {
    "--chefe": c(PALETTE.chefe.hex),
    "--inimigo": c(PALETTE.inimigo.hex),
    "--neutro": PALETTE.neutro.hex,
    "--fundo": BACKDROPS.fundo,
    "--painel": BACKDROPS.painel,
    "--elevado": BACKDROPS.elevado,
  };
  // Uma por classe (F85): `--classe-baluarte` … `--classe-patrulheiro`.
  for (const id of CLASS_IDS) tokens[`--classe-${id}`] = c(PALETTE.classes[id].hex);
  return tokens;
}

/** Aplica as variáveis no elemento raiz (no boot e quando o modo daltônico muda, F60). */
export function applyPaletteTokens(root: { style: { setProperty(name: string, value: string): void } }, colorblind = false): void {
  for (const [name, value] of Object.entries(paletteTokens(colorblind))) root.style.setProperty(name, value);
}
